/**=========================================================
 * Module: folder.js
 * Folder Controller
 =========================================================*/

 App.controller('FolderController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'ngDialog', 'LocalRestangular', '$sce', '$interval', 'DataService', '$filter', 'toaster',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, ngDialog, LR, $sce, $interval, D, $filter, toaster) {
   "use strict";

   $scope.folder = $state.params.filter.replace(/~2F/g, CONFIG.folderSeparator);
   $scope.splitted = $scope.folder.split(CONFIG.folderSeparator)
   $scope.folderSeparator = CONFIG.folderSeparator
   $scope.encodedFolder = $state.params.filter
   $scope.parentFolder = $scope.folder.split(CONFIG.folderSeparator).splice(0, $scope.splitted.length-1).join('~2F')

   $scope.pop = function (type, title, text) {
    toaster.pop(type, title, text, 0, 'trustedHtml');
  };


   $scope.selected = []
   $scope.selectAll = false
   $scope.selectAllFolders = false
   $scope.extEnabled = null
   $scope.filesEnabled = true
   $scope.foldersEnabled = true
   //$scope.selectingAttrs = {}
   $scope.selectedFiles = []
   $scope.selectedFolders = []

   $scope.$on('$addFolderToFileList', function(event, data){
       addSelectedFolder(data.name.replace($scope.baseFolder, $scope.folder.indexOf($scope.folderSeparator)>=0 ? $scope.folder.substr(0, $scope.folder.indexOf($scope.folderSeparator)) : $scope.folder))
       updateAqratorFiles()
   })

   $scope.$on('$addFileToFileList', function(event, data){
        addSelectedFile(data.name.replace($scope.baseFolder, $scope.folder.indexOf($scope.folderSeparator)>=0 ? $scope.folder.substr(0, $scope.folder.indexOf($scope.folderSeparator)) : $scope.folder))
        updateAqratorFiles()
    })

   $scope.$on('$removeElementFromFileList', function(event, data){
        var index = findInSelected(data.filename);
        if(index>=0){
            removeI(index)
        }
        updateAqratorFiles()
   })

    var addSelectedFile = function(name) { addSelected(name, false) }
    var addSelectedFolder = function(name) { addSelected(name, true) }
    var addSelected = function(name, isFolder){
        if($scope.aqratorActionForm){
            var field = $scope.aqratorActionForm.fields.filter(function(f){ return ($scope.aqratorActionForm.selectingField && $scope.aqratorActionForm.selectingField==f.name) || (!$scope.aqratorActionForm.selectingField && f.type=='filelist')})[0]
            if(field.limit){
                if($scope.selected.filter(function(s){ return ($scope.aqratorActionForm.selectingField && $scope.aqratorActionForm.selectingField==s.field) || (!$scope.aqratorActionForm.selectingField)}).length==field.limit){
                    return false
                }
            }
        }
        $scope.selected.push({
            filename: name,
            isFolder: isFolder,
            field: ($scope.aqratorActionForm && $scope.aqratorActionForm.selectingField) || null 
        })
        if(!isFolder)$scope.selectedFiles.push(name)
        if(isFolder)$scope.selectedFolders.push(name)
    }
    var removeAllFiles = function(){
        $scope.selected = $scope.selected.filter(function(f){ return f.isFolder===true})
        $scope.selectedFiles.splice(0, $scope.selectedFiles.length)
        updateAqratorFiles()
    }
    var removeAllFolders = function(){
        $scope.selected = $scope.selected.filter(function(f){ return f.isFolder===false})
        $scope.selectedFolders.splice(0, $scope.selectedFolders.length)
        updateAqratorFiles()
    }
    var removeI = function(index){
        let name = $scope.selected[index].filename
        if(!$scope.selected[index].isFolder){
            $scope.selectedFiles.splice($scope.selectedFiles.indexOf(name),1)
        }
        if($scope.selected[index].isFolder){
            $scope.selectedFolders.splice($scope.selectedFolders.indexOf(name),1)
        }
        $scope.selected.splice(index, 1)
    }
    var findInSelected = function(name){
        for(var i=0; i<$scope.selected.length; i++){
            if($scope.selected[i].filename==name) return i;
        }
        return -1;
    }

   $scope.$watch('selectAll', function(){
        removeAllFiles()
        if($scope.selectAll && $scope.filesEnabled){
            for(var k in $scope.content.files){
                if(!($scope.extEnabled && !$scope.extEnabled[$scope.content.files[k].ext])){
                    if($scope.content.files[k].visible){
                        addSelectedFile($scope.folder + CONFIG.folderSeparator + $scope.content.files[k].name)
                    }
                }
            }
        }
        updateAqratorFiles()
   })
   $scope.$watch('selectAllFolders', function () {
        removeAllFolders()
        if ($scope.selectAllFolders && $scope.foldersEnabled) {
            for (var k in $scope.content.dirs) {
                addSelectedFolder($scope.folder + CONFIG.folderSeparator + $scope.content.dirs[k].name)
            }
        }
        updateAqratorFiles()
   })
    $scope.toggleSelectFile = function($event, name){
        var ext = /(?:\.([^.]+))?$/.exec(name)[1]
        if($event && $event.target && $event.target.localName!=='a' && $scope.filesEnabled && !($scope.extEnabled && !$scope.extEnabled[ext])){ 
            $event.stopPropagation();
            $event.preventDefault();
            var filename = $scope.folder + CONFIG.folderSeparator + name;
            var index = findInSelected(filename);
            if(index>=0){
                removeI(index)
            } else {
                addSelectedFile(filename)
            }
        }
        updateAqratorFiles()
    }
    $scope.preventDefault = function($event) {
        $event.preventDefault()
    }
    $scope.toggleSelectFolder = function($event, name){
        if($event && $event.target && $event.target.localName!=='a' && $scope.foldersEnabled){
            $event.stopPropagation();
            $event.preventDefault();
            var filename = $scope.folder + CONFIG.folderSeparator + name;
            if(name=='.') filename = $scope.folder
            var index = findInSelected(filename);
            if(index>=0){
                removeI(index)
            } else {
                addSelectedFolder(filename)
            }
        }
        updateAqratorFiles()
    }

    var updateAqratorFiles = function(){
        if($scope.aqrator && $scope.aqrator.action && $scope.aqrator.action.model && $scope.aqratorActionForm && $scope.aqratorActionForm.fields){
            for(var i=0; i<$scope.aqratorActionForm.fields.length; i++){
                var f = $scope.aqratorActionForm.fields[i]
                if(f.type=='filelist'){
                    if(f.selective){
                        $scope.aqrator.action.model[f.name] = $scope.selected.filter(function(s) { return s.field==f.name })
                    } else {
                        $scope.aqrator.action.model[f.name] = $scope.selected
                    }
                }
            }
        }
        $scope.hasFileSelected = $scope.selected.filter(function(f){ return !f.isFolder}).length
        $scope.hasFolderSelected = $scope.selected.filter(function(f){ return f.isFolder}).length
    }

    $scope.openExplorer = function(path){
        LR.one('explorer', path || $scope.realFolder).get().then(function(){}).catch(console.error);
    }

   $scope.page = {
       title: '',
       subTitle: ''
    };

    

    $scope.fileFilter = { ext: {}, suffix: {}, search: '' }
    $scope.hasFilter = false
    $scope.setFilter = function(type, filter){
        if(filter!==undefined){
            if($scope.fileFilter[type][filter]){
                delete $scope.fileFilter[type][filter]
            } else {
                $scope.fileFilter[type][filter] = true
            }
        }
        for(var i in $scope.content.files){
            let extVisible = false
            let hasExtFilter = false
            for(let k in $scope.fileFilter.ext){
                hasExtFilter = true
                if($scope.content.files[i].ext==k){
                    extVisible = true
                }
            }
            let sfxVisible = false
            let hasSfxFilter = false
            for(let k in $scope.fileFilter.suffix){
                hasSfxFilter = true
                if($scope.content.files[i].suffix==k){
                    sfxVisible = true
                }
            }
            let visible = true
            if(hasExtFilter && !extVisible) visible = false
            if(hasSfxFilter && !sfxVisible) visible = false
            if($scope.fileFilter.search){
                if($scope.content.files[i].name.toLowerCase().indexOf($scope.fileFilter.search.toLowerCase())<0){
                    visible = false
                }
            }
            $scope.hasFilter = hasExtFilter || hasSfxFilter || $scope.fileFilter.search
            $scope.content.files[i].visible = visible
            if(!visible){
                var index = findInSelected($scope.folder + CONFIG.folderSeparator + $scope.content.files[i].name);
                if(index>=0){
                    removeI(index)
                    updateAqratorFiles()
                }
            }
        }
        var fArray = $scope.content.files.filter(function(f){ return f.visible })
        setExtensionsAndSuffixes(fArray)
        $scope.visibleFiles = fArray.length
    }

    var extractSuffix = function(f){
        var regex = new RegExp('[_-]([a-zA-Z]{2,3}([_-][a-zA-Z]{2,4})?)\\.'+f.ext)
        var matches = f.name.match(regex)
        //L.log(matches)
        return matches ? matches[1] : ''
    }

    var setExtensionsAndSuffixes = function(files){
        $scope.extensions = {}
        $scope.suffixes = {}
        for (var i = 0; i < files.length; i++) {
            var f = files[i]
            var suffix = extractSuffix(f)
            $scope.extensions[f.ext] = $scope.extensions[f.ext] ? $scope.extensions[f.ext]+1 : 1
            if(suffix){
             $scope.suffixes[suffix] = $scope.suffixes[suffix] ? $scope.suffixes[suffix]+1 : 1
            }
        }
    }

    

   $scope.load = function (refresh) {
       if ($scope.folder) {
           $scope.breadcrumbs = [];
           var bc = ''
           for (var i = 0; i < $scope.splitted.length; i++) {
               if (bc) bc += '~2F'
               bc += $scope.splitted[i]
               $scope.breadcrumbs.push({
                   name: $scope.splitted[i],
                   path: bc
               })
           }
           $scope.current = $scope.breadcrumbs.pop()
           //$scope.page.title = $scope.splitted[0] //$scope.folder
           if (!refresh) {
               D.query('project', 'code=' + $scope.splitted[0], { cache: false }).then(
                   function (resp) {
                       $scope.project = resp[0];
                   }).catch(console.error)
           }
           
           LR.one('fs', CONFIG.folderRoot + $scope.folder).get()
               .then(function (result) {
                   $scope.realFolder = result.folder;
                   $scope.baseFolder = result.baseFolder
                   $scope.page.title = $scope.realFolder
                   for (var i = 0; i < result.files.length; i++) {
                       var f = result.files[i]
                       f.visible = true
                       var suffix = extractSuffix(f)
                       f.suffix = suffix
                   }
                   setExtensionsAndSuffixes(result.files)
                   $scope.content = result
               }).catch(console.error)
       }
   }
   $scope.load();

    $scope.aqrator = {
        actions: null,
        action: null
    }

    LR.one('aqrator', '').get()
    .then(function(result){
        $scope.aqrator.actions = result.actions;
        $scope.aqrator.fileactions = result.fileactions;
    }).catch(console.error)

    $scope.openAction = function(a){
        $scope.aqrator.action = a;
        $scope.aqratorActionForm = null

        if(a){
            LR.one('aqrator', a.link).get()
                .then(function(resp){
                    $scope.aqrator.action = Object.assign($scope.aqrator.action, resp)
                    $scope.extEnabled = null
                    var deselectAll = false
                    if($scope.aqrator.action.fileExtensions){
                        $scope.extEnabled = {}
                        for(var i in $scope.aqrator.action.fileExtensions){
                            $scope.extEnabled[$scope.aqrator.action.fileExtensions[i]] = true
                        }
                        deselectAll = true
                    }
                    if($scope.aqrator.action.fileExtensions===null){
                        $scope.extEnabled = { 'fileSelectionEnabled': false }
                        deselectAll = true
                    }
                    if(deselectAll){
                        $scope.selectAll = false
                        $scope.selectAllFolders = false
                        removeAllFiles()
                        removeAllFolders()
                    }
                    if($scope.aqrator.action.enableFiles===false){
                        $scope.filesEnabled = false
                        $scope.selectAll = false
                        removeAllFiles()
                    }
                    if($scope.aqrator.action.enableFolders===false){
                        $scope.foldersEnabled = false
                        $scope.selectAllFolders = false
                        removeAllFolders()
                    }
                    $scope.aqrator.action.model = $scope.aqrator.action.model || {}
                    $scope.aqrator.action.model.currentFolder = $scope.realFolder
                    if(a.link=='makezip' && $scope.selectedFiles[0]){
                        $scope.aqrator.action.model.zipFileName = $scope.selectedFiles[0].slice(0, $scope.selectedFiles[0].lastIndexOf('.')).split(CONFIG.folderSeparator).pop()
                    }
                    if(a.link=='backupfiles'){
                        $scope.aqrator.action.model.backupName = $scope.current.name
                    }
                    if(a.link=='csvsplitter'){
                        $scope.aqrator.action.model.client = $scope.parentFolder.split('-')[0].toLowerCase()
                        D.query('project', 'group=' + $scope.aqrator.action.model.client + '&status=analysis').then(function(response){
                            response.sort(function(a, b) { return a.code > b.code ? 1 : -1})
                            $scope.aqrator.action.fields.filter(function(f){ return f.name=='projects'})[0].available = false
                            $timeout(function(){
                                $scope.aqrator.action.model.projects = [$scope.parentFolder.split('~2F')[0]]
                                $scope.aqrator.action.fields.filter(function(f){ return f.name=='projects'})[0].data = response
                                $scope.aqrator.action.fields.filter(function(f){ return f.name=='projects'})[0].available = true
                            }, 1500)
                        }).catch(console.error)
                    }
                    if($scope.aqrator.action.autoSelectCurrentFolder){
                        addSelectedFolder($scope.folder)
                    }
                    if($scope.aqrator.action.autoSelectCurrentSubFolders){
                        $scope.selectAllFolders = true
                    }

                    $scope.aqratorAfterConfirm = function(val){
                        $scope.aqratorActionForm.status = 'submitting'
                        $scope.aqrator.status='loading'
                        ngDialog.open({
                            template: '/app/views/entities/aqrator-'+$scope.aqrator.action.link+'.html',
                            className: 'ngdialog-theme-large ngdialog-theme-xxlarge',
                            scope: $scope,
                            cache: false
                        })
                        LR.one('aqrator','').customPOST({
                            aqrator: {
                                action: $scope.aqrator.action.link,
                                data: $scope.aqrator.action.model
                            }

                        }).then(function(response){
                            $scope.aqrator.status='completed'
                            $scope.aqrator.result = response
                            $scope.aqratorActionForm.status = 'submitted'
                            $scope.load(true);
                        }).catch(function(err){
                            $scope.aqrator.status='error'
                            $scope.aqrator.error = err
                            $scope.aqratorActionForm.status = 'error'
                        })
                    }

                    $scope.aqratorActionForm = {
                        title: $scope.aqrator.action.title,
                        status: '',
                        type: '',
                        baseFolder: $scope.baseFolder,
                        realFolder: $scope.realFolder,
                        info: $scope.aqrator.action.info,
                        model: $scope.aqrator.action.model,
                        fields: $scope.aqrator.action.fields,
                        beforeValidate: function(){
                            for(var j=0; j<this.fields.length; j++){
                                var field = this.fields[j];
                                if(field.type=='xliffrules'){
                                    this.model[field.name] = field.rules
                                }
                            }
                        },
                        validate: function(){
                            var errors = [];
                            for(var j=0; j<this.fields.length; j++){
                                var field = this.fields[j];
                                if(field.required && field.available && (!this.model[field.name] || (Array.isArray(this.model[field.name]) && this.model[field.name].length===0))){
                                    errors.push({field:field,error:'required'});
                                }
                            }
        
        
                            if(errors.length) {
                                var errorMessages ="<ul>";
                                for(var i=0; i<errors.length; i++){
                                    var e = errors[i];
                                    errorMessages += "<li>"
                                        +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: e.field.label || $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                        +"</li>";
                                }
                                errorMessages += "</ul>";
                                $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                return false;
                            }
                            else return true;
                        },
                        submit: function(){
                            this.beforeValidate()
                            if(this.validate()){
                                if($scope.aqrator.action.dontAskConfirm){
                                    $scope.aqratorAfterConfirm();
                                }else{
                                    ngDialog.openConfirm({
                                        template: '/app/views/entities/confirm.html',
                                        className: 'ngdialog-theme-default',
                                        scope: $scope
                                    }).then(function (value) {
                                        $scope.aqratorAfterConfirm();
                                    });
                                }
                                
                            }
                        }
                    }

                    updateAqratorFiles()
                }).catch(console.error)
        

            
        } else {
            $scope.extEnabled = null
        }
    }

   $scope.viewFile = function(f){

    $scope.file = null
    ngDialog.open({
        template: '/app/views/entities/file-viewer.html',
        className: 'ngdialog-theme-large ngdialog-theme-xxlarge',
        scope: $scope,
        cache: false
    })
       
    LR.one('fs', CONFIG.folderRoot + $scope.folder + CONFIG.folderSeparator + f.name).get()
        .then(function(result){
            if(f.name.endsWith('.docx')){
                result.fileContent = $sce.trustAsHtml(result.fileContent)
            }
            $scope.file = result
        }).catch(console.error)
   }

    $scope.copyFilesView = ''
    $scope.setCopyFilesView = function(c){
        $scope.copyFilesView = c
    }
    $scope.copyFilesFilter = function(d){
        return !$scope.copyFilesView || ($scope.copyFilesView==d.state) || ($scope.copyFilesView=='diffN' && d.state=='distinct' && !d.diffNumber) || ($scope.copyFilesView=='diffT' && d.state=='distinct' && d.diffNumber)
    }

    $scope.movedComparedFile = {}
    $scope.moveComparedFile = function(d){
        let f = d.relativePath + d.name2
        if($scope.movedComparedFile[f]){
            //da nodiff a diff
            LR.one('fs', 'move').customPUT({
                from: d.path2 + '_AqratorCompareNoDiff' + d.relativePath + d.name2, 
                to: d.path2 + '_AqratorCompareDiff' + d.relativePath + d.name2
            }).then(function(res) {
                $scope.movedComparedFile[f] = false
                $scope.load()
            }).catch(function(err) {
                $scope.movedComparedFile[f] = true
            })
        } else {
            //da diff a nodiff
            LR.one('fs', 'move').customPUT({
                from: d.path2 + '_AqratorCompareDiff' + d.relativePath + d.name2, 
                to: d.path2 + '_AqratorCompareNoDiff' + d.relativePath + d.name2
            }).then(function(res) {
                $scope.movedComparedFile[f] = true
                $scope.load()
            }).catch(function(err) {
                $scope.movedComparedFile[f] = false
            })
        }
    }

    $scope.greaterThan = function(prop, val){
        return function(item){
          return item[prop] > val;
        }
    }

     
 }
 ]);